
















































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { authorizationService } from "@/shared/services/AuthorizationService";
import { UserProfileItem } from "@/components/header/UserProfile/UserProfileItem";
import { JwtService } from "@/shared/services/JwtService";
import { RouterNames } from "@/router/routernames";
import { API } from "@/shared/api";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
@Component({
  components: {},
})
export default class UserProfile extends Vue {
  public items: UserProfileItem[] = [
    {
      icon: "fad fa-sign-out-alt brand-icon-menu fa-lg",
      text: "",
      i18n: "Cerrar sesión",
      id: 0,
    },
    {
      icon: "fad fa-user-circle brand-icon-menu fa-lg",
      text: "",
      i18n: "Ver perfil",
      id: 1,
    },
    {
      icon: "far fa-check-square brand-icon-menu fa-lg",
      text: "",
      i18n: "Avanzado",
      id: 2,
    },
  ];
  public menu: boolean = false;
  public image_default = false;
  public refre = false;
  public date = 2;
  public ocultar_precios = false;

  created() {
    this.ocultar_precios = !ocultarcamposModule.Ocultar_tarjeta_efectivo;
  }

  /**
   * get getImagen
   */
  public get getImagen() {
    return (
      API.webApiBaseImages +
      JwtService.jwtDecode().nameid +
      ".png?rnd=" +
      this.date
    );
  }
  public get userName() {
    return authorizationService.userName();
  }
  public changeOcultarPrecios() {
    if (this.ocultar_precios) {
      ocultarcamposModule.MostrarTarjetaEfectivo();
    } else {
      ocultarcamposModule.NoMostrarTarjetaEfectivo();
    }
  }
  public logout() {
    authorizationService.logout();
    this.$router.push("/login");
  }

  public opcion(item: UserProfileItem) {
    if (item.id === 0) {
      this.logout();
    } else if (item.id === 1) {
      this.$router.push({ name: RouterNames.mi_perfil });
    } else if (item.id === 2) {
      this.ocultar_precios = !this.ocultar_precios;
      this.changeOcultarPrecios();
    }
    this.menu = false;
  }
  public imageLoadError(event: any) {
    this.image_default = true;
  }
}
